import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { KinshipDegreeViewModel } from '../../Screen/KinshipDegree/KinshipDegreeViewModel';
import { KinshipDegreeViewController, KinshipDegreeViewControllerDelegate } from '../../Screen/KinshipDegree/KinshipDegreeViewController';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class KinshipDegreeCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, KinshipDegreeViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepgrauparentesco")
        return (<ProtectedRoute requiredPermissions={['info_bas.grau_parent.*']} path="/:base/grau-parentesco" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'info_bas.grau_parent.adicionar',
                    edit: 'info_bas.grau_parent.editar',
                    delete: 'info_bas.grau_parent.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Grau Parentesco"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new KinshipDegreeViewModel()
        return (<ProtectedRoute requiredPermissions={['info_bas.grau_parent.adicionar', 'info_bas.grau_parent.editar']} path="/:base/grau-parentesco/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<KinshipDegreeViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepgrauparentesco") {
            navigation.history.push(`grau-parentesco/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepgrauparentesco") {
            navigation.history.push(`grau-parentesco/cad/${idSelection}`);
            return;
        }
    }

}